import { IAPIParameters } from '@cian/mf-registry-legacy/browser';

import { IOpenAuthModalParameters } from '../../../../../shared/common/repositories/header-frontend/v1/get-header-microfrontend/microfrontend/api/v1/set-region-id/types';
import { ensureHeaderMicrofrontend } from '../../microfrontend';

export async function openAuthModal(parameters?: IOpenAuthModalParameters): Promise<void> {
  const microfrontend = await ensureHeaderMicrofrontend();

  return microfrontend?.call('/v2/open-auth-modal/', parameters as IAPIParameters);
}
